import { render } from "./InfoField.vue?vue&type=template&id=fffb8504&scoped=true"
import script from "./InfoField.vue?vue&type=script&lang=js"
export * from "./InfoField.vue?vue&type=script&lang=js"

import "./InfoField.vue?vue&type=style&index=0&id=fffb8504&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffb8504"]])

export default __exports__